<template>
  <PageHeading title="Компания и контакты" description="Данные вашей компании в CRM." />
  <div class="two-column"><section class="card"><h2>{{ client.name_org }}</h2><dl><template v-for="field in fields" :key="field[0]"><dt>{{ field[0] }}</dt><dd>{{ field[1] || 'Не указано' }}</dd></template></dl><p class="muted">Для изменения реквизитов обратитесь к менеджеру.</p></section><ManagerCard /></div>
</template>
<script>
import PageHeading from '@/components/PageHeading.vue'
import ManagerCard from '@/components/ManagerCard.vue'
export default {
  components: { PageHeading, ManagerCard },
  computed: {
    client() { return this.$store.state.user },
    fields() { const c = this.client; return [['ИНН', c.inn], ['Юридический адрес', c.adress_org], ['Почтовый адрес', c.post_org], ['Электронная почта', c.email_org], ['Контактное лицо', [c.u_family_org, c.u_name_org, c.u_otch_org].filter(Boolean).join(' ')], ['Контакты', c.u_contact_org]] }
  }
}
</script>
